<template>
  <section v-if="residences">
    <div
      id="residenceList"
      v-if="residences.length > 0"
      :class="{
        'c-residence-list--cards': listType === 'cards',
      }"
      class="c-residence-list"
    >
      <residence-item
        v-for="(residence, index) in residences"
        :key="residence.id"
        :id="residence.id"
        :index="index"
      />
    </div>
    <residence-list-empty
      v-else
    />
  </section>
</template>

<script>
// Data models
import Residence from '@/models/Residence';

// UI Components
import ResidenceItem from '@/components/ResidenceItem.vue';
import ResidenceListEmpty from '@/components/ResidenceListEmpty.vue';

export default {
  name: 'ResidenceList',
  components: {
    ResidenceItem,
    ResidenceListEmpty,
  },
  computed: {
    selectedBuilding() {
      return this.$store.state.entities.buildings.selectedBuilding;
    },
    currentSection() {
      return this.$store.state.entities.illustrations.currentSection;
    },
    residenceStatus() {
      return this.$store.state.entities.residences.residenceStatus;
    },
    selectedLevel() {
      return this.$store.state.entities.residences.selectedLevel;
    },
    selectedResidenceType() {
      return this.$store.state.entities.residences.selectedResidenceType;
    },
    bathroomState() {
      return this.$store.state.entities.residences.bathrooms;
    },
    bedroomState() {
      return this.$store.state.entities.residences.bedrooms;
    },
    minPrice() {
      return this.$store.state.entities.residences.minPrice;
    },
    maxPrice() {
      return this.$store.state.entities.residences.maxPrice;
    },
    minSize() {
      return this.$store.state.entities.residences.minSize;
    },
    maxSize() {
      return this.$store.state.entities.residences.maxSize;
    },
    order() {
      return this.$store.state.entities.residences.order;
    },
    residences() {
      return Residence.query()
        .whereHas('buildings', query => {
          if (this.selectedBuilding != 'all') {
            query.where('id', this.selectedBuilding);
          }
        })
        .whereHas('availability', query => {
          if (this.residenceStatus != 'all') {
            query.where('slug', this.residenceStatus);
          }
        })
        .whereHasNot('availabilty', query => {
          query.where('slug', 'hidden');
        })
        /*
        TODO: Lage nytt filter
        .whereHas('bedrooms', query => {
          if (this.bedroomState.length > 0) {
            query.where('slug', this.bedroomState);
          }
        })
        .whereHas('bathrooms', query => {
          if (this.bathroomState.length > 0) {
            query.where('slug', this.bathroomState);
          }
        })
        .whereHas('levels', query => {
          if (this.selectedLevel !== 'all') {
            query.where('slug', this.selectedLevel);
          }
        })
        .whereHas('residenceType', query => {
          if (this.selectedResidenceType != 'all') {
            query.where('slug', this.selectedResidenceType);
          }
        })
        .where(residence => {
          if (isNaN(this.minPrice) === false && this.minPrice != 0) {
            return residence.price >= this.minPrice;
          }
        })
        .where(residence => {
          if (isNaN(this.maxPrice) === false && this.maxPrice != 0) {
            return residence.price <= this.maxPrice;
          }
        })
        .where(residence => {
          if (isNaN(this.minSize) === false && this.minSize != 0) {
            return residence.size >= this.minSize;
          }
        })
        .where(residence => {
          if (isNaN(this.maxSize) === false && this.maxSize != 0) {
            return residence.size <= this.maxSize;
          }
        })*/
        .orderBy(
          this.order.orderBy,
          this.order.sortOrder
        )
        .get();
    },
    listType() {
      return this.$store.state.entities.residences.listType;
    },
    activeIllustrationId() {
      return this.$store.state.entities.illustrations.activeIllustration;
    },
  },
  watch: {
    activeIllustrationId() {
      this.updateResidenceListHeight();
    },
  },
  mounted() {
    this.updateResidenceListHeight();
  },
  methods: {
    updateResidenceListHeight() {
      const container = document.querySelector('.c-illustration-container');
      if (container) {
        const height = container.clientHeight;
        if (height > 500) {
          document.getElementById('residenceList').style.setProperty('--residence-list-height', height + 'px');
        }
      }
    },
  },
};
</script>
